// Map timing metrics
export const TIME_TO_MAP_IDLE_ON_PAGE_LOAD = 'time_to_map_idle_on_page_load'
export const TIME_TO_MAP_IDLE_ON_PAGE_LOAD_STOP =
  'time_to_map_idle_on_page_load_stop'

export const TIME_TO_MAP_LOAD_ON_PAGE_LOAD = 'time_to_map_load_on_page_load'
export const TIME_TO_MAP_LOAD_ON_PAGE_LOAD_STOP =
  'time_to_map_load_on_page_load_stop'

export const TIME_TO_MAP_STYLE_LOAD_ON_PAGE_LOAD =
  'time_to_map_style_load_on_page_load'
export const TIME_TO_MAP_STYLE_LOAD_ON_PAGE_LOAD_STOP =
  'time_to_map_style_load_on_page_load_stop'

export const INIT_STYLESHEET_TIME = 'init_stylesheet_measure'
export const INIT_STYLESHEET_START = 'init_stylesheet_start'
export const INIT_STYLESHEET_STOP = 'init_stylesheet_stop'

export const INIT_LAYER_MANAGEMENT_TIME = 'init_layer_management_measure'
export const INIT_LAYER_MANAGEMENT_START = 'init_layer_management_start'
export const INIT_LAYER_MANAGEMENT_STOP = 'init_layer_management_stop'

// Markup timing metrics
// Markup loading metrics
export const TIME_TO_MARKUPS_LOAD = 'time_for_markup_load'
export const TIME_TO_MARKUPS_LOAD_START = 'time_for_markup_load_started'
export const TIME_TO_MARKUPS_LOAD_STOP = 'time_for_markup_load_finished'

export const TIME_TO_WAYPOINTS_LOAD = 'time_for_waypoints_load'
export const TIME_TO_WAYPOINTS_LOAD_START = 'time_for_waypoints_load_started'
export const TIME_TO_WAYPOINTS_LOAD_STOP = 'time_for_waypoints_load_finished'

export const TIME_TO_WAYPOINTS_LOAD_BBOX = 'time_for_waypoints_load_bbox'
export const TIME_TO_WAYPOINTS_LOAD_START_BBOX =
  'time_for_waypoints_load_started_bbox'
export const TIME_TO_WAYPOINTS_LOAD_STOP_BBOX =
  'time_for_waypoints_load_finished_bbox'

export const TIME_TO_LINES_LOAD = 'time_for_lines_load'
export const TIME_TO_LINES_LOAD_START = 'time_for_lines_load_started'
export const TIME_TO_LINES_LOAD_STOP = 'time_for_lines_load_finished'

export const TIME_TO_LINES_LOAD_BBOX = 'time_for_lines_load_bbox'
export const TIME_TO_LINES_LOAD_START_BBOX = 'time_for_lines_load_started_bbox'
export const TIME_TO_LINES_LOAD_STOP_BBOX = 'time_for_lines_load_finished_bbox'

export const TIME_TO_TRACKS_LOAD = 'time_for_tracks_load'
export const TIME_TO_TRACKS_LOAD_START = 'time_for_tracks_load_started'
export const TIME_TO_TRACKS_LOAD_STOP = 'time_for_tracks_load_finished'

export const TIME_TO_TRACKS_LOAD_BBOX = 'time_for_tracks_load_bbox'
export const TIME_TO_TRACKS_LOAD_START_BBOX =
  'time_for_tracks_load_started_bbox'
export const TIME_TO_TRACKS_LOAD_STOP_BBOX =
  'time_for_tracks_load_finished_bbox'

export const TIME_TO_SHAPES_LOAD = 'time_for_shapes_load'
export const TIME_TO_SHAPES_LOAD_START = 'time_for_shapes_load_started'
export const TIME_TO_SHAPES_LOAD_STOP = 'time_for_shapes_load_finished'

export const TIME_TO_SHAPES_LOAD_BBOX = 'time_for_shapes_load_bbox'
export const TIME_TO_SHAPES_LOAD_START_BBOX =
  'time_for_shapes_load_started_bbox'
export const TIME_TO_SHAPES_LOAD_STOP_BBOX =
  'time_for_shapes_load_finished_bbox'

export const TIME_TO_ROUTES_LOAD = 'time_for_routes_load'
export const TIME_TO_ROUTES_LOAD_START = 'time_for_routes_load_started'
export const TIME_TO_ROUTES_LOAD_STOP = 'time_for_routes_load_finished'

// Markup rendering metrics
export const TIME_TO_WAYPOINTS_RENDER = 'time_to_waypoints_render'
export const TIME_TO_WAYPOINTS_RENDER_START = 'time_to_waypoints_render_start'
export const TIME_TO_WAYPOINTS_RENDER_STOP = 'time_to_waypoints_render_stop'

export const TIME_TO_LINES_RENDER = 'time_to_lines_render'
export const TIME_TO_LINES_RENDER_START = 'time_to_lines_render_start'
export const TIME_TO_LINES_RENDER_STOP = 'time_to_lines_render_stop'

export const TIME_TO_TRACKS_RENDER = 'time_to_tracks_render'
export const TIME_TO_TRACKS_RENDER_START = 'time_to_tracks_render_start'
export const TIME_TO_TRACKS_RENDER_STOP = 'time_to_tracks_render_stop'

export const TIME_TO_SHAPES_RENDER = 'time_to_shapes_render'
export const TIME_TO_SHAPES_RENDER_START = 'time_to_shapes_render_start'
export const TIME_TO_SHAPES_RENDER_STOP = 'time_to_shapes_render_stop'

export const TIME_TO_ROUTES_RENDER = 'time_to_routes_render'
export const TIME_TO_ROUTES_RENDER_START = 'time_to_routes_render_start'
export const TIME_TO_ROUTES_RENDER_STOP = 'time_to_routes_render_stop'
